export class Fuente {
    model = {
        id: { value: null, export: false },
        fuente_riesgo: {
            value: null, header: 'FUENTE DEL RIESGO (AMENAZA)', required: 'Campo requerido', table: true
        },
        sigla_riesgo: {
            value: '', export: true, header: 'ID del Riesgo', required: 'Campo requerido', maxLength: 'Máximo 300 caracteres',
            filterPlaceholder: 'ID del Riesgo', minLength: 'Mínimo 4 caracteres', max: 100, min: 3, filterField: 'sigla_riesgo',
        },
        riesgo: { header: 'RIESGO(S)', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        probabilidad: { header: 'PROBABILIDAD (P1)', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        contagio: { header: 'Contagio', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', table: true },
        legal: { header: 'Legal', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: false },
        operacional: { header: 'Operativo', value: null, required: 'Selecione una opcion', optionLabel: 'nombre', export: true, table: true },
        reputacional: { header: 'REPUTACIONAL', value: null, required: 'Selecione una opcion', table: true, export: true },
        evaluacion_riesgo: { header: 'EVALUACION DEL RIESGO (RANQUEO DE LA PRIORIDAD DEL RIESGO)', value: null, required: 'Selecione una opcion', table: true },
        tratamiento_riesgo: { header: 'TRATAMIENTO DEL RIESGO', value: null, required: 'Selecione una opcion', table: true },
        consecuencia: { header: 'CONSECUENCIAS-IMPACTO', value: null, required: 'Selecione una opcion', },
        riesgo_inherente_valor: { header: 'NIVEL DE RIESGO INHERENTE', value: null },
        riesgo_inherente_nivel: { header: 'Nivel riesgo inherente', value: null },
        impacto: { header: 'DESCRIPCIÓN DE LA CONSECUENCIA (IMPACTO)', value: null },
        alerta_tolerancia_riesgo_residual: { header: 'ALERTA TOLERANCIA DE RIESGO INHERENTE', value: '' },
    }
}
